import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import CircularProgress from '@material-ui/core/CircularProgress';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import 'date-fns';
import { format } from 'date-fns/esm'
import moment from 'moment';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import ErrorIcon from '@material-ui/icons/Error';
import CloseIcon from '@material-ui/icons/Close';
import red from '@material-ui/core/colors/red';
import deLocale from 'date-fns/locale/de';
import { withStyles } from '@material-ui/core/styles';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import request from 'superagent'
import * as Constants from '../constants'

const styles = theme => ({
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  icon: {
    fontSize: 20,
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
});

class EditChildDialog extends React.Component {
  state = {
    loading: false,
    first_name: null,
    last_name: null,
    dob: null,
    age: null,
    note: null,
    min_date: new Date(new Date().getFullYear() - 20 /* Obergrenze: 20 Jahre */, 5, 30),
    max_date: new Date(new Date().getFullYear() - 3 /* Untergrenze: 3 Jahre */, 9, 1),
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.value, ["error_" + name]: false });
  };

  handleDateChange = date => {
    let age = this.calculateAge(date);
    this.setState({ dob: date, age: age });
  }

  onReset = () => {
    this.setState({ first_name: null, last_name: null, dob: null, age: null, note: null, loading: false });
  }

  editChild = () => {
    this.setState({ loading: true });
    if (this.state.first_name !== "" && this.state.last_name !== "") {
      if (this.state.first_name === null) this.state.first_name = this.props.child.first_name;
      if (this.state.last_name === null) this.state.last_name = this.props.child.last_name;
      this.state.dob = this.state.dob === null ? this.props.child.dob : moment(this.state.dob).format('DD.MM.YYYY');
      if (this.state.note === null) this.state.note = this.props.child.note;
      let currentComponent = this;
      request.post(Constants.BACKEND_URL)
        .set('Content-Type', 'application/x-www-form-urlencoded')
        .set('accept', 'json')
        .send({ command: "editchild", child_id: this.props.child.id, first_name: this.state.first_name, last_name: this.state.last_name, dob: this.state.dob, note: this.state.note, parent_id: this.props.parentId })
        .end((err, res) => {
          var result = res.text.trim();
          if (result === "1") {
            //erfolgreich editiert
            currentComponent.props.onChildEdited();
            currentComponent.onReset();
          } else {
            currentComponent.setState({ snackbar_open: true, loading: false });
          }
        });
    } else {
      this.setState({ error_first_name: this.state.first_name === "", error_last_name: this.state.last_name === "", error_dob: this.state.dob === null, loading: false });
    }
  }

  onEnterPressed = (ev) => {
    if (ev.key === 'Enter') {
      this.editChild();
      ev.preventDefault();
    }
  }

  calculateAge(birthday) {
    var ageDifMs = Date.now() - birthday.getTime();
    var ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

  handleSnackbarClose = () => {
    this.setState({ snackbar_open: false });
  }

  render() {
    const { classes, theme, fullScreen } = this.props;

    return (
      <Dialog fullScreen={fullScreen} open={this.props.open}>
        <DialogTitle>{"Kind bearbeiten"}</DialogTitle>
        <DialogContent style={{ paddingLeft: 20, paddingRight: 20 }}>
          <DialogContentText>Bitte ändern Sie die Daten unten ab.</DialogContentText>
          {/* Vorname */}
          <TextField label="Vorname" inputProps={{ maxLength: 30 }} value={this.state.first_name === null ? this.props.child.first_name : this.state.first_name} onChange={this.handleChange('first_name')} onKeyPress={this.onEnterPressed} style={{ width: "49%", marginRight: "2%", marginTop: 5 }} error={this.state.error_first_name} required />
          {/* Nachname */}
          <TextField label="Nachname" inputProps={{ maxLength: 30 }} value={this.state.last_name === null ? this.props.child.last_name : this.state.last_name} onChange={this.handleChange('last_name')} onKeyPress={this.onEnterPressed} style={{ width: "49%", marginTop: 5 }} error={this.state.error_last_name} required />
          {/* Geburtsdatum */}
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={deLocale}>
            <DatePicker label="Geburtsdatum" value={this.state.dob === null ? moment(this.props.child.dob, 'DD.MM.YYYY') : this.state.dob} minDate={format(this.state.min_date, 'yyyy-MM-dd')} maxDate={format(this.state.max_date, 'yyyy-MM-dd')} onChange={this.handleDateChange} openTo="year" views={["year", "month", "date"]} disableFuture cancelLabel="Abbrechen" okLabel="OK" invalidLabel="Ungültige Eingabe" format="dd.MM.yyyy" style={{ marginTop: 15, width: "25%", marginRight: "2%" }} required error={this.state.error_dob} ref={node => { this.picker = node; }} />
          </MuiPickersUtilsProvider>
          {/* Alter */}
          <TextField label="Alter" value={this.state.age === null ? this.calculateAge(moment(this.props.child.dob, 'DD.MM.YYYY').toDate()) : this.state.age} style={{ width: "8%", marginRight: "2%", marginTop: 15 }} disabled />
          {/* Notizen */}
          <TextField label="Allergien, Unverträglichkeiten, etc." inputProps={{ maxLength: 300 }} multiline rowsMax="4" value={this.state.note === null ? this.props.child.note : this.state.note} onKeyPress={this.onEnterPressed} onChange={this.handleChange('note')} style={{ marginTop: 15, width: "63%" }} />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onCancel} variant="contained" disabled={this.state.loading}>Abbrechen</Button>
          <Button onClick={this.onReset} variant="contained" disabled={this.state.loading}>Formular zurücksetzen</Button>
          <Button onClick={this.editChild} variant="contained" disabled={this.state.loading} color="primary" autoFocus>
            {"Daten übernehmen"}
            {this.state.loading && <CircularProgress size={24} className={classes.buttonProgress} />}
          </Button>
        </DialogActions>
        {/* Error-Snackbar */}
        <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={this.state.snackbar_open} autoHideDuration={3000} onClose={this.handleSnackbarClose}>
          <SnackbarContent
            message={
              <span className={classes.message}>
                <ErrorIcon className={classes.icon} />
                Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.
              </span>
            }
            action={[
              <IconButton color="inherit" onClick={this.handleSnackbarClose}>
                <CloseIcon style={{ fontSize: 20 }} />
              </IconButton>,
            ]}
            style={{ backgroundColor: red[600] }} />
        </Snackbar>
      </Dialog>
    );
  }
}

EditChildDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  fullScreen: PropTypes.bool.isRequired,
  theme: PropTypes.object.isRequired,
  open: PropTypes.bool,
  child: PropTypes.object.isRequired,
  onCancel: PropTypes.func.isRequired,
  onChildEdited: PropTypes.func.isRequired,
};

export default withMobileDialog()(withStyles(styles, { withTheme: true })(EditChildDialog));
